import { render, staticRenderFns } from "./feedback-list-item.vue?vue&type=template&id=3d348932"
import script from "./feedback-list-item.vue?vue&type=script&lang=js"
export * from "./feedback-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports